import {Injectable} from '@angular/core';
import {ParentService} from "./ParentService";
import {TimeStatisticDto} from "../dto/TimeStatisticDto";
import {ExamsResultsDto} from "../dto/ExamsResultsDto";
import {ExamsSubjectResultsDto} from "../dto/ExamsSubjectResultsDto";
import {ExamStatisticsDataDto} from "../dto/ExamStatisticsDataDto";
import {catchError} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";

@Injectable()
export class AnalyticsService extends ParentService{


  //STATISTICS
  public getTimeStatistics(examReference, subReference){
      return this.http.get<TimeStatisticDto[]>(this.shared.MAGNAMENT_URL+'/getTimeStatistics/'+examReference+'/'+subReference, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public getExamsResults(subReference){
    return this.http.get<ExamsResultsDto[]>(this.shared.MAGNAMENT_URL+'/getExamsResults/'+subReference, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public getExamsSubjectResults(subReference){
    return this.http.get<ExamsSubjectResultsDto[]>(this.shared.MAGNAMENT_URL+'/getExamsSubjectResults/'+subReference, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public getExamStatisticsData(examReference){
    return this.http.get<ExamStatisticsDataDto>(this.shared.MAGNAMENT_URL+'/getExamStatisticsData/'+examReference, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

}
